/*
 *
 * Copyright 2018 Odysseus Data Services, inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 *  limitations under the License.
 *
 * Company: Odysseus Data Services, Inc.
 * Product Owner/Architecture: Gregory Klebanov
 * Authors: Alexandr Saltykov, Pavel Grafkin, Vitaly Koulakov, Anton Gackovka
 * Created: March 3, 2017
 *
 */

import API from 'services/Api';
import services from '../apiServices';

import { actionTypes, pageSize, paths } from 'modules/Admin/const';
import { IAppAction } from 'actions';
import { get } from 'lodash';

function getUsers(params: { query: string }) {
	return services.users.find({ query: params });
}

function getAvailableVocabularies(userId) {
	return services.vocabularies.find({
		query: {
			userId,
		},
	});
}

function load(page: number, pageSize: number, queryUser?: string, pendingOnly?: boolean) {
  return services.licenses.find({
  	query: {
  		page,
  		pageSize,
  		queryUser,
  		pendingOnly,
  	}
  });
}

function reloadCurrentPage() {
	return (dispatch, getState) => {
		const state = getState();
		const currentPage = parseInt(
			get(state, 'routing.locationBeforeTransitions.query.page', '1'),
			10,
		) || 1;
		const queryUser = get(state, 'form.licenseFilter.values.username', '');
		const pathname = get(state, 'routing.locationBeforeTransitions.pathname', '');
		const pendingOnly = pathname === paths.licenses(true);

		return dispatch(load(currentPage, pageSize, queryUser, pendingOnly));
	};
}

function loadPendingCount() {
	return services.licensePendingCount.find();
}

function remove(vocabId: number) {
	return services.licenses.remove(vocabId);
}

function cancelRequest(licenseId: number) {
	return services.licenseRequests.remove(licenseId);
}

function create(userId: number, vocabularyV4Ids: Array<number>) {
	return services.licenses.create({
		userId,
		vocabularyV4Ids,
	});
}

function resolve(id: number, accepted: boolean) {
	return services.licenseAccept.create({
		id,
		accepted,
	});
}

export default {
  create,
  cancelRequest,
  getUsers,
  getAvailableVocabularies,
  load,
  loadPendingCount,
  reloadCurrentPage,
  remove,
  resolve,
};
